const filtersToQuerySkipProperties = [
  'showFilters'
];

export {
  filtersToQuerySkipProperties
};
